import React from 'react';
import { useNavigate } from 'react-router-dom';

export default function AccessDenied() {
  const navigate = useNavigate();
  return (
    <div style={{
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      minHeight: '60vh', padding: 24,
    }}>
      <div style={{
        background: '#1B2A6B', borderRadius: 20, padding: '48px 56px',
        textAlign: 'center', maxWidth: 420, width: '100%',
        boxShadow: '0 8px 32px rgba(27,42,107,0.25)',
      }}>
        <div style={{ fontSize: 56, marginBottom: 16 }}>🔒</div>
        <h2 style={{ color: '#fff', fontSize: 22, fontWeight: 800, margin: '0 0 10px' }}>
          Access Restricted
        </h2>
        <p style={{ color: 'rgba(255,255,255,0.65)', fontSize: 14, margin: '0 0 28px', lineHeight: 1.6 }}>
          You don't have permission to view this page. Contact your administrator if you believe this is a mistake.
        </p>
        <button
          onClick={() => navigate('/dashboard')}
          style={{
            background: '#C9A84C', color: '#1B2A6B', border: 'none',
            borderRadius: 10, padding: '12px 28px', fontWeight: 700,
            fontSize: 14, cursor: 'pointer',
          }}
        >
          Go to Dashboard
        </button>
      </div>
    </div>
  );
}
